import axios from "axios";
import { getEnv } from "../config";
import APIError from "../models/ApiError";

const api = axios.create({
  baseURL: getEnv("REACT_APP_API_URL"),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    // Add any other headers your API requires, such as authentication tokens
  },
});

export const getRecaptchaKey = async () => {
  try {
    const response = await api.get("/auth/idecaba/recaptcha-key");

    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const sendContactEmail = async (nombre, email, mensaje) => {
  try {
    const payload = { nombre, email, mensaje };
    const response = await api.post("/contact/", payload);
    return response.data; // { mensaje: "Correo enviado exitosamente" }
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message || error.message,
      );
    }
    throw error;
  }
};

export const sendContactPortalEmail = async (
  nombre,
  email,
  mensaje,
  captchaToken,
) => {
  try {
    const payload = { nombre, email, mensaje, captchaToken };
    const response = await api.post("/contact/portal", payload);
    return response.data; // { mensaje: "Correo enviado exitosamente" }
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message || error.message,
      );
    }
    throw error;
  }
};
